
import React from 'react'
import { HashRouter } from "react-router-dom"
import { createBrowserHistory } from "history"
import { useDispatch } from 'react-redux'
import { updateProfile } from './components/redux/actions/authAction'
import MainPage from './pages/MainPage'
// import { useHistory, useLocation } from 'react-router';
// import { BrowserRouter as Router, } from "react-router-dom"

const ConfigUrlApi = async () => {
  const response = await fetch('assets/config/config.json')
  return await response.json();
}

 function App() {

  ConfigUrlApi().then(config => {
    localStorage.setItem("UrlAPI", JSON.stringify(config.API))
    // console.log(config.API) 
  });

  const history = createBrowserHistory();

  // console.log(history);
  const dispatch = useDispatch()
  React.useEffect(() => {
    const Token = JSON.parse(localStorage.getItem('token'));
    if (Token) {
      if (Token.expires_in * 1000 < Date.now()) {
        localStorage.removeItem('token')
        localStorage.removeItem('profile')
        dispatch(updateProfile(null))
      }
    }

  })

  // if (location.hash.startsWith('#/')) {
    // history2.push(location.hash.replace('#', '')) // or history.replace
  // }

  return (
    <HashRouter history={history}>
      <MainPage />
    </HashRouter>
  );
}

export default App;
